import { ReactComponent as Archive } from '../images/archive.svg';
import { ReactComponent as Classic } from '../images/classic.svg';
import { ReactComponent as Daily } from '../images/daily.svg';
import { ReactComponent as Settings } from '../images/settings.svg';
import { ReactComponent as Statistics } from '../images/statistics.svg';

type Page = 'archive' | 'classic' | 'daily' | 'settings' | 'statistics';
type Props = {
    showMenu: boolean,
    loadDailyPuzzle: () => void,
    setPage: React.Dispatch<React.SetStateAction<Page>>,
    setShowMenu: React.Dispatch<React.SetStateAction<boolean>>,
    setShowSettings: React.Dispatch<React.SetStateAction<boolean>>,
    setShowStatistics: React.Dispatch<React.SetStateAction<boolean>>,
};

const Menu = ({ showMenu, loadDailyPuzzle, setPage, setShowMenu, setShowSettings, setShowStatistics }: Props): JSX.Element => {
    const doAction = (action: Page): void => {
        if (action === 'daily') {
            loadDailyPuzzle();
        } else if (action === 'settings') {
            setShowSettings(true);
        } else if (action === 'statistics') {
            setShowStatistics(true);
        } else {
            setPage(action);
        }

        setShowMenu(false);
    }

    return (
        <div id="menu" className={showMenu ? 'active' : ''}>
            <h4>Menu</h4>
            <div className="menu-option" onClick={() => doAction('daily')}>
                <Daily />
                <div className="menu-name">Daily Mosaic</div>
            </div>
            <div className="menu-option" onClick={() => doAction('classic')}>
                <Classic />
                <div className="menu-name">Number Puzzle</div>
            </div>
            <div className="menu-option" onClick={() => doAction('archive')}>
                <Archive />
                <div className="menu-name">Archive</div>
            </div>
            <hr />
            <div className="menu-option" onClick={() => doAction('settings')}>
                <Settings />
                <div className="menu-name">Settings</div>
            </div>
            <div className="menu-option" onClick={() => doAction('statistics')}>
                <Statistics />
                <div className="menu-name">Statistics</div>
            </div>
            <div id="close-menu" onClick={() => setShowMenu(false)}>x</div>
        </div>
    )
}

export default Menu;
